export default "__VITE_ASSET__d48a99ec__"